"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkedOrderLines = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getLinkedOrderLines = (order_lines, order_line_id) => {
    const linked_lines = [];
    if (!order_lines)
        return linked_lines;
    order_lines.forEach((line) => {
        if (!line.versions)
            return;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return;
        if (latest_version.linked_line_id === order_line_id) {
            linked_lines.push(line);
        }
    });
    return linked_lines;
};
exports.getLinkedOrderLines = getLinkedOrderLines;
